.header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  background: color-mix(in srgb, var(--surface-base) 88%, transparent);
  backdrop-filter: blur(14px);
  border-bottom: 1px solid var(--edge);
}

.identity {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  min-width: 0;
}

.title {
  font-family: var(--font-chrome);
  font-size: var(--step-0);
  letter-spacing: var(--track-mid);
  text-transform: uppercase;
  color: var(--ink-bright);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.client {
  font-size: var(--step-1);
  color: var(--ink-faint);
  white-space: nowrap;
}

.controls {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.density {
  display: inline-flex;
  border: 1px solid var(--edge);
  border-radius: var(--radius);
  overflow: hidden;
  background: var(--surface-panel);
}

.densityOption {
  padding: 0.3rem 0.6rem;
  font-family: var(--font-chrome);
  font-size: 0.625rem;
  letter-spacing: var(--track-tight);
  text-transform: uppercase;
  color: var(--ink-faint);
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: color 160ms var(--ease-out), background 160ms var(--ease-out);
}

.densityOption + .densityOption {
  border-left: 1px solid var(--edge);
}

.densityOption:hover {
  color: var(--ink);
}

.densityOption[aria-pressed='true'] {
  color: var(--surface-void);
  background: var(--ink);
}

.download {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  font-family: var(--font-chrome);
  font-size: 0.625rem;
  letter-spacing: var(--track-tight);
  text-transform: uppercase;
  color: var(--ink-bright);
  text-decoration: none;
  background: var(--surface-panel);
  border: 1px solid var(--edge-strong);
  border-radius: var(--radius);
  transition: border-color 160ms var(--ease-out);
}

.download:hover {
  border-color: var(--ink-faint);
}

.bundleSize {
  color: var(--ink-faint);
}

.textButton {
  padding: 0.3rem 0.4rem;
  font-family: var(--font-chrome);
  font-size: 0.625rem;
  letter-spacing: var(--track-tight);
  text-transform: uppercase;
  color: var(--ink-faint);
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: color 160ms var(--ease-out);
}

.textButton:hover {
  color: var(--ink-bright);
}

.welcome {
  max-width: 46ch;
  margin: var(--space-4) auto var(--space-2);
  padding: 0 var(--space-3);
  font-size: var(--step-2);
  color: var(--ink-dim);
  text-align: center;
}

.grid {
  padding: var(--space-2);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.row {
  display: flex;
}

/* The photographs never get the gloss; the shine stays in the chrome. */
.tile {
  position: relative;
  padding: 0;
  border: 0;
  cursor: zoom-in;
  overflow: hidden;
  background-color: var(--surface-panel);
  background-size: cover;
  background-position: center;
  border-radius: 1px;
  flex: 0 0 auto;
}

.thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Fades in over the inlined placeholder rather than replacing it abruptly. */
  animation: reveal 420ms var(--ease-out) both;
}

@keyframes reveal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .thumb {
    animation: none;
  }
}

.tile::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgb(0 0 0 / 0%);
  transition: background 200ms var(--ease-out);
  pointer-events: none;
}

.tile:hover::after {
  background: rgb(0 0 0 / 18%);
}

.playBadge {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-size: 1.5rem;
  color: rgb(255 255 255 / 88%);
  text-shadow: 0 2px 12px rgb(0 0 0 / 70%);
  pointer-events: none;
}

.message {
  min-height: 60vh;
  display: grid;
  place-content: center;
  gap: var(--space-2);
  text-align: center;
  color: var(--ink-dim);
}

.empty {
  padding: var(--space-6) var(--space-3);
  text-align: center;
  color: var(--ink-dim);
}

@media (max-width: 40rem) {
  .header {
    justify-content: center;
  }

  .controls {
    justify-content: center;
    width: 100%;
  }
}
